import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCompanyService from "../../../services/ShoppingCompanyService";
import ShoppingCompany from "../../../models/ShoppingCompany";
import { CreateShoppingCompany } from "./ui/buttons";
import ShoppingCompaniesTable from "./ui/shopping-companies-table";
import ShoppingCompaniesSkeleton from "./skeleton/shopping-companies-skeleton";
import useShoppingCategories from "../../../hooks/useShoppingCategories";
import Select from "../../../components/select";

export default function ShoppingCompaniesPage() {
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  const [items, setItems] = useState<ShoppingCompany[]>([]);
  const [loading, setLoading] = useState(true);
  const { shoppingCategories, loading: loadingCategories } = useShoppingCategories();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const fetchItems = useCallback(async () => {
    const api = new ShoppingCompanyService();
    try {
      setLoading(true);
      const data = await api.getShoppingCompanies(selectedCategoryId);
      setItems(data);
    } catch (error) {
      console.error("Error fetching shopping companies:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedCategoryId]);

  useEffect(() => {
    void fetchItems();
  }, [fetchItems, reload]);  

  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Companies", href: "/admin/shopping-companies" },
        ]}
      />
      <div className="flex flex-row justify-between items-center">
        <CreateShoppingCompany />
        <Select
          id="shoppingCategoryId"
          name="shoppingCategoryId"
          placeholder="All categories"
          items={shoppingCategories
            .filter((category) => category.id != null)
            .map((category) => ({
              name: category.name,
              id: category.id,
            }))}
          onChange={(e) => {
            const value = Number(e.target.value);
            setSelectedCategoryId(Number.isFinite(value) && value > 0 ? value : null);
          }}
          value={selectedCategoryId ?? ""}
          disabled={loadingCategories}
        />
      </div>
      {loading ? (
        <ShoppingCompaniesSkeleton />
      ) : (
        <ShoppingCompaniesTable items={items} />
      )}
    </div>
  );
}
